<template>
  <div
    v-if="job"
    id="job-list-item"
    ref="job"
    :class="{ hide: !job.isEnabledToChange }"
    @click="loadStudent(job)"
  >
    <el-collapse-item :id="`modal-${job.id}`" :name="job.id">
      <template #title>
        <div v-if="job.status !== 'done' && job.status !== 'canceled' && job.isEnabledToChange && accountStore.permissions && accountStore.permissions.customerJobsEdit" class="check">
          <el-checkbox v-model="currentEdit" @change="handleEdit"/>
        </div>
        <div class="col-sm-1 date-begin" style="left:15px">
          {{ formatDate(job.dateBegin) }} <span id="tippy-template-name" class="overflow-ellipsis"> {{ job.template ? `${job.template.label} - ` : '' }} {{ job.id }}</span>
        </div>
        <div class="col-sm-2 hours hidden-sm">
          {{ formatHours(job.dateBegin) }} à {{ formatHours(job.dateEnd) }} <span>Horaires</span>
        </div>
        <div class="col-sm-3 address hidden-sm" @mouseenter="createOrUpdateAddressTippy">
          <div v-if="job.address && job.address.shopName" class="shop-name">{{ job.address.shopName }}</div>
          <div :id="`tippy-${job.id}`">{{ adresse }}<span>Adresse</span>
          </div>
          <!-- The template already has its own label next to the date; only the mission tags
               the ops put on the job are missing from the row (SP-14527). -->
          <div v-if="jobTags.length" class="job-tags">
            <span
              v-for="tag in visibleTags"
              :key="tag.id"
              class="job-tag job-tag-mission"
            >{{ tag.name }}</span>
            <span
              v-if="hiddenTagCount"
              class="job-tag job-tag-more"
              @click.stop="allTagsShown = true"
            >+{{ hiddenTagCount }}</span>
          </div>
        </div>
        <div class="col-sm-1 student-count hidden-sm">
          {{ job.countStudent }}/{{ job.countStudentAsked }} <span>{{ $brand.workers }}</span>
        </div>
        <div
          class="col status"
          :class="{ modify: job.status === 'modify', done: job.status === 'done', pending: job.status === 'pending', staffed: job.status === 'staffed', canceled: job.status === 'canceled' }"
        >
          {{ formatStatus(job.status) }} <span>Statut</span>
        </div>
        <div v-if="job.status !== 'done'" class="col hidden-sm avatar-students">
          <AvatarStudents :students="job.student_pictures" :student-asked="job.countStudentAsked"/>
        </div>
        <div v-if="job.global_feedback && job.global_feedback.score !== 0" class="col global-note hidden-sm">
          <el-rate
            :model-value="job.global_feedback.score"
            disabled
            :colors="['#ffd859','#ffd859','#ffd859']"
          />
          <span class="job-rate">Votre appréciation</span>
        </div>
        <div v-if="!job.global_feedback && job.status === 'done'" class="col global-note hidden-sm">
          <el-rate
            v-model="ratingDone"
            :colors="['#ffd859','#ffd859','#ffd859']"
            @change="openAndNoteGlobal(ratingDone)"
          />
          <span class="job-rate">Notez cette mission</span>
        </div>
        <div
          v-if="job.global_feedback && !job.global_feedback.score && job.status === 'done'"
          class="col global-note hidden-sm"
        >
          <el-rate
            v-model="ratingDone"
            :colors="['#ffd859','#ffd859','#ffd859']"
            @change="openAndNoteGlobal(ratingDone)"
          />
          <span class="job-rate">Notez cette mission</span>
        </div>
      </template>
      <div class="job-content">
        <div class="description">
          <p v-if="jobDetail && (jobDetail.lunchMealAmount || jobDetail.breakTimeMinutes || jobDetail.tempAssignmentReason)" class="description-title">
            <IconDescription />
            Description
          </p>
          <div class="row description-content">
            <div class="col">
              <div v-if="jobDetail">
                <div v-if="jobDetail.breakTimeMinutes">
                  <div class="description-sub">
                    <div class="title">Temps de pause :</div>
                    {{ jobDetail.breakTimeMinutes }} minutes
                  </div>
                </div>

                <div v-if="jobDetail.lunchMealAmount">
                  <div class="description-sub">
                    <div class="title">Panier repas :</div>
                    {{ jobDetail.lunchMealAmount }} €
                  </div>
                </div>

                <div v-if="jobDetail.tempAssignmentReason">
                  <div class="description-sub">
                    <div class="title">Motif de recours :</div>
                    {{ selectedReasonType(jobDetail.tempAssignmentReason) }}
                  </div>
                  <div class="description-sub">
                    <div class="title">Justification du motif de recours :</div>
                    {{ jobDetail.tempAssignmentReason.description ? jobDetail.tempAssignmentReason.description : jobDetail.tempAssignmentReason.absenceReason }}
                  </div>
                </div>

                <template v-if="job.status !== 'done'">
                  <div v-if="jobDetail.description.descriptionOffer" class="description-sub">
                    <div class="title">Objectif de la mission :</div>
                    <SimpleMarkdown
                      v-if="jobDetail.description.description"
                      :source="jobDetail.description.description"
                    />
                  </div>
                  <div v-if="jobDetail.description.descriptionSkillsNeeded" class="description-sub">
                    <div class="title">Compétences recherchées :</div>
                    <SimpleMarkdown
                      v-if="jobDetail.description.descriptionSkillsNeeded"
                      :source="jobDetail.description.descriptionSkillsNeeded"
                    />
                  </div>
                  <div v-if="jobDetail.address.comment" class="description-sub">
                    <div class="title">Informations accès (code, bâtiment,etc…) :</div>
                    <SimpleMarkdown
                      v-if="jobDetail.address.comment"
                      :source="jobDetail.address.comment"
                    />
                  </div>
                  <div v-if="jobDetail.description.descriptionOtherInfos" class="description-sub">
                    <div class="title">Informations pratiques (logistique, photos terrain, tenue recommandée...) :</div>
                    <SimpleMarkdown
                      v-if="jobDetail.description.descriptionOtherInfos"
                      :source="jobDetail.description.descriptionOtherInfos"
                    />
                  </div>
                  <div v-if="jobDetail.address.contacts && jobDetail.address.contacts.length !== 0" class="description-sub">
                    <div class="title">Contact(s) sur place :</div>
                    <div v-for="(contact, idx) in jobDetail.address.contacts" :key="idx">
                      <span>{{ contact.firstname }} </span>
                      <span v-if="contact.lastname"> {{ contact.lastname }} </span>
                      <span v-if="contact.phone">, {{ contact.phone }}</span>
                      <span v-if="contact.email">, {{ contact.email }}</span>
                      <span v-if="contact.post">, {{ contact.post }}</span>
                    </div><br>
                  </div>
                  <div v-if="jobDetail.description.descriptionStudentPopAdvantage" class="description-sub">
                    <div class="title">Les + {{ $brand.label }} :</div>
                    <SimpleMarkdown
                      v-if="jobDetail.description.descriptionStudentPopAdvantage"
                      :source="jobDetail.description.descriptionStudentPopAdvantage"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="job.status !== 'done'" class="col-sm-12 col-lg-5 col-12 briefing-block">
              <p class="description-title">
                <IconBriefcase />
                Briefing
              </p>
              <ListSkeleton
                v-if="isLoadingDetail"
                :count="2"
                class="briefing-skeleton"
              >
                <el-skeleton-item variant="rect" class="skeleton-briefing" />
              </ListSkeleton>
              <p v-else-if="!job_infos || job_infos.length === 0">
                Vous n'avez renseigné aucun élément de briefing, contactez-votre opérationnel pour compléter les
                fiches.
              </p>
              <ul>
                <template v-for="(job_info, idx) in job_infos" :key="idx">
                  <li v-if="job_info.link || job_info.requirements">
                    <a
                      v-if="job_info.type !== 'requirements'"
                      :href="job_info.link.url"
                      target="_blank"
                      @click="mxTrack"
                    >
                      <span class="jobinfo-description">{{ job_info.link.label }}</span>
                    </a>
                    <a
                      v-if="job_info.type === 'requirements'"
                      href="#"
                      @click="openRequirementsDialog(job_info.requirements)"
                    >
                      <span class="jobinfo-description">Les indispensables</span>
                    </a>
                  </li>
                </template>
              </ul>
            </div>
            <div
              v-if="job.status === 'done' && students && Object.keys(students).length > 0"
              class="col-12"
            >
              <p class="description-title">
                <i class="fa fa-user"/>
                <span v-if="Object.keys(students).length > 1">Notez vos {{ $brand.workers }}</span>
                <span v-else>Notez votre {{ $brand.worker }}</span>
              </p>
              <div v-for="student in students" :key="student.id">
                <JobStudentNotation :student="student" :job="job"/>
              </div>
            </div>
            <div v-if="job.status === 'done'" class="col-12">
              <p class="description-title"><i class="fa fa-star"/>Notez le service {{ $brand.label }}</p>
              <ListSkeleton v-if="isLoadingDetail" :count="1">
                <SkeletonCell />
              </ListSkeleton>
              <div v-if="jobDetail && Object.keys(jobDetail).length > 0">
                <JobGlobalNotation :job="jobDetail" :score="ratingDone"/>
              </div>
            </div>
            <div v-if="job.status !== 'done'" class="col-sm-12 col-lg-7 col-12">
              <p class="description-title"><i class="fa fa-user"/>Contact mission</p>
              <div class="row students">
                <JobStudentSkeleton v-if="isLoadingDetail" />
                <div v-if="referer" class="col-sm-12">
                  <div class="student referer">
                    <SingleAvatarStudent
                      v-if="referer"
                      :picture="referer.mainPicture ? referer.mainPicture.format.small : null"
                      size="45px"
                      :first-name="referer.firstName"
                      :gender="referer.gender"
                    />
                    <div class="name watcher">
                      {{ referer.firstName }} {{ referer.lastName }}
                      <span>Contact {{ $brand.label }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="brandAmbassador" class="col-sm-12">
                  <div class="student referer">
                    <SingleAvatarStudent
                      v-if="brandAmbassador"
                      :picture="brandAmbassador.mainPicture ? brandAmbassador.mainPicture.format.small : null"
                      size="45px"
                      :first-name="brandAmbassador.firstName"
                      :gender="brandAmbassador.gender"
                    />
                    <div class="name watcher">
                      {{ brandAmbassador.firstName }} {{ brandAmbassador.lastName }}
                      <span>Brand ambassador</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div
                v-if="job.status !== 'done'"
                cols="12"
                sm="12"
                lg="8"
                class="student-block"
              >
                <p class="description-title"><i class="fa fa-user"/>{{ job.countStudent }}/{{
                  job.countStudentAsked
                }} {{ $brand.workers }}</p>
                <div class="row students">
                  <JobStudentSkeleton
                    v-if="isLoadingDetail && job.countStudent > 0"
                    :count="Math.min(job.countStudent, 4)"
                    column-class="col-sm-6 col-md-3 col-lg-3"
                  />
                  <div
                    v-for="student in students"
                    :key="student.id"
                    class="col-sm-6 col-md-3 col-lg-3"
                  >
                    <div class="student" @click="selectStudent(student)">
                      <SingleAvatarStudent
                        v-if="student"
                        :picture="student.mainPicture ? student.mainPicture : null"
                        size="45px"
                        :first-name="student.firstName"
                        :gender="student.gender"
                      />
                      <div class="name">
                        {{ student.firstName }} {{ student.lastName.slice(0, 1) }}.
                        <span v-if="student.leader === false">{{ student.phone ? student.phone : '----' }}</span>
                        <span v-if="student.leader === true" class="referer">{{ student.phone ? student.phone : '----' }}
                          <el-tooltip
                            effect="dark"
                            content="Referent"
                            :show-after="300"
                            placement="bottom"
                            :show-arrow="false"
                          >
                            <span class="referer-picto item">R</span>
                          </el-tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="job.status !== 'done' && job.status !== 'canceled' && job.isEnabledToChange" class="col-12 btns">
              <el-button
                v-if="accountStore.permissions && accountStore.permissions.customerJobsEdit"
                type="primary"
                class="btn-green"
                @click="openEditDialog"
              ><i
                class="fa fa-pencil"
                aria-hidden="true"
              />
                Modifier
              </el-button>
              <el-button
                v-if="accountStore.permissions && accountStore.permissions.customerJobsCancel"
                type="danger"
                class="btn-warm"
                @click="openCancelDialog"
              ><i
                class="fa fa-close"
                aria-hidden="true"
              />
                Annuler
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>
    <StudentModal
      :current-student="selectedStudent"
      :modal-visible="dialogVisible"
      :note-is-disabled="jobNoteDisabled()"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import JobStudentNotation from '@/components/MyJobs/JobStudentNotation';
import JobGlobalNotation from '@/components/MyJobs/JobGlobalNotation';
import jobService from '@/services/jobs/';
import AvatarStudents from '@/components/MyJobs/AvatarStudents';
import StudentModal from '@/components/MyStudents/StudentModal';
import SingleAvatarStudent from '@/components/MyStudents/SingleAvatarStudent';
import SimpleMarkdown from '@/components/Global/SimpleMarkdown';
import ListSkeleton from '@/components/Global/ListSkeleton';
import SkeletonCell from '@/components/Global/SkeletonCell';
import JobStudentSkeleton from '@/components/MyJobs/JobStudentSkeleton';
import tippy from 'tippy.js';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useJobActionsStore } from '@/stores/jobActions';
import notifyLoadFail from '@/utils/notifyLoadFail';
import IconBriefcase from '@/assets/icons/briefcase.svg?component';
import IconDescription from '@/assets/icons/description.svg?component';

export default {
  components: {
    IconBriefcase,
    IconDescription,
    JobStudentNotation,
    JobGlobalNotation,
    AvatarStudents,
    StudentModal,
    SingleAvatarStudent,
    SimpleMarkdown,
    ListSkeleton,
    SkeletonCell,
    JobStudentSkeleton,
  },
  props: ['job', 'open'],
  data() {
    return {
      addressTippy: null,
      allTagsShown: false,
      currentEdit: false,
      jobDetail: null,
      detailRequested: false,
      detailLoadError: false,
      students: null,
      referer: null,
      brandAmbassador: null,
      job_infos: null,
      selectedStudent: null,
      dialogVisible: false,
      ratingDone: 0,
      reasons: [
        { id: 'employee_replacement', title: 'Remplacement salarié' },
        { id: 'temporary_activity_increase', title: 'Accroissement temporaire de l’activité' },
        { id: 'seasonal_employment', title: 'Emploi saisonnier' },
        { id: 'waiting_recruitment', title: 'En attente de recrutement ' },
        { id: 'temporary_use_contract', title: 'Contrat temporaire d’usage' },
      ],
    };
  },
  computed: {
    ...mapStores(useAccountStore, useJobActionsStore),
    isLoadingDetail() {
      return this.detailRequested && !this.jobDetail && !this.detailLoadError;
    },
    jobTags() {
      return this.job.tags || [];
    },
    // Beyond three mission tags the card shows a "+n" chip, expanded on click (SP-14527).
    visibleTags() {
      return this.allTagsShown ? this.jobTags : this.jobTags.slice(0, 3);
    },
    hiddenTagCount() {
      return this.jobTags.length - this.visibleTags.length;
    },
    adresse() {
      let addressValue = '-';
      // full address
      if (this.job && this.job.address && this.job.address.street) {
        addressValue = `${this.job.address.street}, ${this.job.address.zipCode} ${this.job.address.city}`;
        // zipcode adresse (Lieux flexibles)
      } else if (this.job && this.job.address && !this.job.address.street && this.job.address.zipCode) {
        addressValue = `Lieux flexibles - ${this.job.address.zipCode} ${this.job.address.city}`;
      } else if (this.job && this.job.address && !this.job.address.street && !this.job.address.zipCode) {
        addressValue = 'Télétravail';
      }
      return addressValue;
    },
  },
  mounted() {
    if (this.open) {
      const modalCloser = document.getElementsByClassName('el-collapse-item__header');
      this.$nextTick(() => {
        modalCloser[0].addEventListener('click', (e) => {
          e.preventDefault();
        });
      });
      const parentModal = document.getElementById(`modal-${this.job.id}`).parentElement;
      const modalOpen = document.getElementById(`modal-${this.job.id}`).firstChild.firstChild;
      this.$nextTick(() => {
        modalOpen.click();
        this.$nextTick(() => {
          parentModal.classList.add('modal-job');
        });
      });
    }

    if (this.job.template) {
      const templateNameEl = document.getElementById('tippy-template-name');
      tippy(templateNameEl, {
        content: `${this.job.template.label}`,
        placement: 'top',
        delay: 400,
        arrow: true,
      });
    }

    if (this.job.status !== 'canceled') {
      this.checkPendingCustomerRequest();
    }
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .format('dddd D MMM YYYY');
    },
    formatHours(date) {
      return moment.tz(date, 'Europe/Paris')
        .format('HH[h]mm');
    },
    formatStatus(status) {
      switch (status) {
        case 'done':
          status = 'Terminé';
          break;
        case 'pending':
          status = 'Staffing en cours';
          break;
        case 'staffed':
          status = 'Staffé';
          break;
        case 'canceled':
          status = 'Annulé';
          break;
        case 'modify':
          status = 'Modif en cours...';
          break;
        default:
          status = 'Pas de status';
      }
      return status;
    },

    createOrUpdateAddressTippy() {
      const el = document.getElementById(`tippy-${this.job.id}`);

      // If the Tippy instance already exists, update the content
      if (this.addressTippy) {
        this.addressTippy.setContent(this.adresse);
      } else {
        // Otherwise, create a new Tippy instance
        this.addressTippy = tippy(el, {
          content: this.adresse,
          placement: 'top',
          delay: 400,
          arrow: true,
          onHidden: () => {
            if (this.addressTippy) {
              this.addressTippy.destroy();
              this.addressTippy = null;
            }
          },
        });
      }
    },
    mxTrack() {
      this.$mixpanel.track('Job Detail Briefing Displayed');
    },
    handleEdit() {
      if (this.currentEdit) {
        this.$emit('selected-to-edit', { job: this.job, jobDetail: this.jobDetail });
      } else {
        this.$emit('unselected-to-edit', { job: this.job, jobDetail: this.jobDetail });
      }
    },
    openCancelDialog() {
      this.currentEdit = true;
      this.$emit('cancel', this.job);
      this.$mixpanel.track('Job Detail Job Cancelled');
    },
    openEditDialog() {
      this.currentEdit = true;
      this.$emit('selected-to-edit', { job: this.job, jobDetail: this.jobDetail });
    },
    openRequirementsDialog(req) {
      this.$mixpanel.track('Job Detail Briefing Displayed');
      this.jobActionsStore.open({ job: this.job, type: 'requirements', requirements: req });
    },
    jobNoteDisabled() {
      return this.job.status !== 'done';
    },
    openAndNoteGlobal(score) {
      this.job.global_feedback = { score };
      this.ratingDone = score;
    },
    closeModal() {
      this.dialogVisible = false;
    },
    checkPendingCustomerRequest() {
      if (this.job && this.job.pending_customer_request) {
        const asPendingCustomerRequest = this.job.pending_customer_request.reduce((acc, val) => val.status === 'pending', 0);
        if (asPendingCustomerRequest) {
          this.job.status = 'modify';
        }
      }
    },
    selectStudent(student) {
      this.$mixpanel.track('Job Detail Student Staffed Opened');
      this.selectedStudent = student;
      this.openModal();
    },
    openModal() {
      this.dialogVisible = true;
    },
    selectedReasonType(tempAssignmentReason) {
      const reason = this.reasons.find((r) => r.id === tempAssignmentReason.type);
      return reason ? reason.title : tempAssignmentReason.type;
    },
    loadStudent(job) {
      this.$mixpanel.track('Job Detail Charged');
      this.currentJob = job;
      this.detailRequested = true;
      this.detailLoadError = false;
      jobService.detail(this.currentJob, (data) => {
        this.students = data.students;
        this.referer = data.referer;
        this.brandAmbassador = data.brandAmbassador;
        this.jobDetail = data;
        if (data.additional_job_infos.length > 0) {
          this.job_infos = data.additional_job_infos;
        }
      }, () => {
        this.detailLoadError = true;
        notifyLoadFail();
      });
    },
  },
};
</script>
